import React, { Component } from "react";
import { Nav, NavItem } from "reactstrap";
import LinkItem from "../LinkItem/LinkItem";
import "./Sidebar.css";

export default class Sidebar extends Component {
  render() {
    return (
      <div className="sidebar">
        <p className="sidebar-section-title">User management</p>
        <Nav vertical>
          <NavItem>
            <LinkItem pathname={this.props.location.pathname} name={"Accounts"} route={"/accounts"}/>
          </NavItem>
          <NavItem>
            <LinkItem pathname={this.props.location.pathname} name={"Users"} route={"/users"}/>
          </NavItem>
        </Nav>

        <p className="sidebar-section-title last-title">Subscription management</p>
        <Nav vertical>
          <NavItem>
            <LinkItem pathname={this.props.location.pathname} name={"Products"} route={"/products"}/>
          </NavItem>
        </Nav>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/Sidebar/Sidebar.js